<tlc-churn-flow-step-template [currentStep]="4">
  <div class="left">
    <div class="heading-container">
      <span class="heading">{{
        'tlc.churn_flow.steps.subscription_loss.heading' | translate
      }}</span>
      <span
        class="subheading"
        [innerHTML]="'tlc.churn_flow.steps.subscription_loss.subheading' | translate"
      ></span>
    </div>
    <span class="losses-heading">{{
      'tlc.churn_flow.steps.subscription_loss.losses.heading' | translate
    }}</span>
    <div class="losses-container">
      <div class="loss">
        <rt-icon name="close" colorToken="colorIconCriticalDefault" />
        <span
          [innerHTML]="'tlc.churn_flow.steps.subscription_loss.losses.loss_1' | translate"
        ></span>
      </div>
      <div class="loss">
        <rt-icon name="close" colorToken="colorIconCriticalDefault" />
        <span
          [innerHTML]="'tlc.churn_flow.steps.subscription_loss.losses.loss_2' | translate"
        ></span>
      </div>
      <div class="loss">
        <rt-icon name="close" colorToken="colorIconCriticalDefault" />
        <span
          [innerHTML]="'tlc.churn_flow.steps.subscription_loss.losses.loss_3' | translate"
        ></span>
      </div>
      @if (careersSiteUrl()) {
        <div class="loss">
          <rt-icon name="close" colorToken="colorIconCriticalDefault" />
          <span
            [innerHTML]="
              'tlc.churn_flow.steps.subscription_loss.losses.loss_4'
                | translate: { link: careersSiteUrl() }
            "
          ></span>
        </div>
      }
      <div class="loss">
        <rt-icon name="close" colorToken="colorIconCriticalDefault" />
        <span
          [innerHTML]="'tlc.churn_flow.steps.subscription_loss.losses.loss_5' | translate"
        ></span>
      </div>
      <span class="notification-info">{{
        'tlc.churn_flow.steps.subscription_loss.losses.notification_info' | translate
      }}</span>
    </div>
    <rt-checkbox [checked]="consentChecked()" (valueChange)="toggleConsent($event)"
      >{{ 'tlc.churn_flow.steps.subscription_loss.confirmation' | translate }}
    </rt-checkbox>

    <div class="buttons-container">
      <rt-button variant="plain" (click)="stayWithTellent()">
        {{ 'tlc.churn_flow.common.stay_with_tellent' | translate }}
      </rt-button>
      <rt-button
        variant="outline"
        class="danger-on-hover"
        (click)="cancelSubscription()"
        [loading]="submitting()"
        [disabled]="!consentChecked()"
      >
        {{ 'tlc.churn_flow.steps.subscription_loss.cta' | translate }}
      </rt-button>
    </div>
  </div>
  <div class="right">
    <tlc-churn-flow-insights />
  </div>
</tlc-churn-flow-step-template>
